module.exports = __webpack_public_path__ + "static/media/openflow@3x.2b4a3e38.png";